export enum LocalStorage {
  CognitoAppClientId = 'cognito_app_client_id',
  ShowNotificationBannerForWorkRecommendedPage = 'showNotificationBannerForWorkRecommendedPage',
}
